import React from 'react';
import Modals from './Modals';
import Play from './Play';

type PlayPageProps = {};

const PlayPage: React.FC<PlayPageProps> = () => (
  <>
    <Modals />
    <Play />
  </>
);
export default PlayPage;
